import { render, staticRenderFns } from "./PartnerFinder.vue?vue&type=template&id=389776e4&scoped=true&"
import script from "./PartnerFinder.vue?vue&type=script&lang=ts&"
export * from "./PartnerFinder.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFinder.vue?vue&type=style&index=0&id=389776e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389776e4",
  null
  
)

export default component.exports